import React from 'react'
import { FlexContainer, FlexItem } from 'components/Flex'
import ProgressSpinner from 'components/ProgressSpinner'
import './styles.sass'

const WorkingIndicator = ({ children }) => (
  <FlexContainer className="working-indicator" direction="column">
    <FlexItem>
      <h4 className="title is-5 is-semibold">{children}</h4>
    </FlexItem>
    <FlexItem className="has-spacing-top">
      <ProgressSpinner
        size={48}
        color="#2395F3"
      />
    </FlexItem>
  </FlexContainer>
)

export default WorkingIndicator



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/WorkingIndicator/index.jsx